var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 25) scale(0.6)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg1",
    x1: 90,
    y1: 90,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sg1)",
    d: "M16.2 59.7c.6-.6 1.4-.9 2.3-.9h79.3c1.5 0 2.2 1.8 1.2 2.8l-15.7 15.7c-.6.6-1.4.9-2.3.9H1.6c-1.5 0-2.2-1.8-1.2-2.8l15.8-15.7zM16.2 1c.6-.6 1.4-1 2.3-1h79.3c1.5 0 2.2 1.8 1.2 2.8L83.3 18.5c-.6.6-1.4 1-2.3 1H1.6C.1 19.5-.6 17.7.4 16.7L16.2 1zM83.3 30c-.6-.6-1.4-.9-2.3-.9H1.6c-1.5 0-2.2 1.8-1.2 2.8l15.8 15.7c.6.6 1.4.9 2.3.9h79.3c1.5 0 2.2-1.8 1.2-2.8L83.3 30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainSolana);
export default __webpack_public_path__ + "static/media/chain-solana.687b2e00d5f231b3e1f1520c2f8c3a4f.svg";
export { ForwardRef as ReactComponent };